<template>
  <div class="checkbox">
    <input
      :id="id"
      type="checkbox"
      :name="id"
      :checked="checked"
      :disabled="disabled"
      @change="$emit('change', $event.target.checked)"
    />

    <label :for="id">
      <slot></slot>
    </label>
  </div>
</template>

<script>
import { nanoid } from "nanoid";

export default {
  name: "SimpleCheckbox",

  model: {
    prop: "checked",
    event: "change",
  },

  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      id: nanoid(),
    };
  },
};
</script>

<style scoped lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  user-select: none;

  input {
    position: relative;
    width: 16px;
    height: 16px;
    border: 1px solid $grey-300;
    border-radius: 4px;
    margin-right: 10px;
    appearance: none;
    cursor: pointer;
    outline: none;

    &:checked {
      border: none;
    }

    &:checked::after {
      position: absolute;
      width: 100%;
      height: 100%;
      content: url(../../assets/icons/checkbox.svg);
    }

    &:disabled {
      background-color: #eee;
      cursor: default;
    }
  }

  label {
    cursor: pointer;
  }
}
</style>
